import { useContext } from 'react';
import SettingsContext from '../../contexts/SettingsContext';

const useSettingsContext = () => {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error('useSettingsContext must be used within SettingsContextProvider!');
  }
  return context;
};

export default useSettingsContext;
